import { err, ok, Result } from "neverthrow"
import _ from 'lodash'
import { CalcScriptCompileError, CompiledCalcScript } from "../scriptcompiler/CompilerTypes"
import { ExecutableCalc, ExecutableCalcCalculateFunction, ExecutableCalcCalculateOk, ExecutableCalcPrecedence } from "./ExecutableTypes"
import { CompiledCalcScriptEvaluator } from "../scriptevaluator/Evaluator"
import { CalcRuntimeError, CalcScriptRuntimeErrorMsgs } from "../scriptevaluator/RuntimeTypes"
import { CalcScriptCompiler } from "../scriptcompiler/ScriptCompiler"
import { FormCalcScript } from "../FormCalcScript"

export class CalcScriptExecutableCreator {
	createFromCompiled({programNode, concepts, calcType}: CompiledCalcScript, outputCid: string, precedence?: ExecutableCalcPrecedence): ExecutableCalc {
		const calculate: ExecutableCalcCalculateFunction = (ctx): Result<ExecutableCalcCalculateOk, CalcRuntimeError> => {
			const rEval = new CompiledCalcScriptEvaluator(programNode, ctx).evaluate()
			if(rEval.isErr()) {
				return err(rEval.error)
			}
			// technically this is a duplicate check to another check that
			// happens within CalcEngine.runCalculations(),
			// but better safe than sorry...
			const evalInferredCalcType = rEval.value.calcType
			if(evalInferredCalcType !== calcType) {
				return err({
					area: 'CalcScriptExecutableCreator calculate',
					message: CalcScriptRuntimeErrorMsgs.ReturnStatementInferredChangedCalcType(calcType, evalInferredCalcType),
				})	
			}
			return ok(rEval.value)
		}
		return new ExecutableCalc({
			calcType,
			precedence,
			outputCid,
			inputCids: [
				...concepts.conceptIds,
				...concepts.subconceptIds,
			],
			selectCalculate: () => calculate,
		})
	}

	createFromScript(script: string, outputCid: string, precedence?: ExecutableCalcPrecedence): Result<ExecutableCalc, CalcScriptCompileError> {
		const rCompile = new CalcScriptCompiler().compile(script)
		if(rCompile.isErr()) {
			return err(rCompile.error)
		}
		return ok(this.createFromCompiled(rCompile.value, outputCid, precedence))
	}

	createFromFormCalcScript(script: FormCalcScript): Result<ExecutableCalc, CalcScriptCompileError> {
		return this.createFromScript(
			script.string,
			script.outputCid,
			script.precedence ?? ExecutableCalcPrecedence.Primary,
		)
	}
}
